/* src/modules/notification/NotificationButton/index.js */

import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import { get, trim, isEmpty } from 'lodash';
import moment from 'moment';
import classNames from 'classnames';
import { Link, withRouter } from 'react-router-dom';

import {
  Badge,
  Button,
  IconButton,
  Menu,
  MenuItem,
  Tooltip,
  Typography,
} from '@material-ui/core';

import {
  Notifications as NotificationsIcon,
  RadioButtonChecked as RadioButtonCheckedIcon,
} from '@material-ui/icons';
import { withStyles } from '@material-ui/core/styles';
import styles from './styles';

import {
  fetchNotification,
  notificationMarkRead,
  subscribeToNotification,
} from '../actions';
import { loadTexts } from '../../../config/texts';

import { texts, handleNavigation } from '../../../config/constants/notification';
const TEXT_KEY = "notification";

class NotificationButton extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      anchorEl: null,
      texts: loadTexts(TEXT_KEY, props.locale)
    };
  }

  componentWillMount() {
    if (this.props.loggedIn) {
      this._subscription = subscribeToNotification({ user: this.props.userId });
      this._subscription.subscribe(data => this.props.dispatchNotif(data.notificationAdded));
    }
  }

  componentDidMount() {
    if (this.props.loggedIn)
      this.fetchNotification();
  }

  componentWillReceiveProps(nextProps) {
    if (!this.props.loggedIn && nextProps.loggedIn) {
      this.fetchNotification();
      this._subscription = subscribeToNotification({ user: this.props.userId });
      this._subscription.subscribe(data => this.props.dispatchNotif(data.notificationAdded));
    }
  }

  componentWillUnmount() {
    if (this._subscription)
      this._subscription.unsubscribe();
  }

  _onOpenMenu = event => this.setState({ anchorEl: event.currentTarget });
  _onCloseMenu = () => this.setState({ anchorEl: null });
  _onClickMark = async (event, _id) => {
    event.stopPropagation();
    await this.props.notificationMarkRead({ notification: [_id] });
    this.fetchNotification();
  };
  _onClickNotif = async notif => {
    this._onCloseMenu();
    if (!notif.read) {
      await this.props.notificationMarkRead({ notification: [notif._id] });
      this.fetchNotification();
    }
    const { key, payload } = notif;
    const { history } = this.props;
    handleNavigation({ history, key, payload });
  };

  fetchNotification = (page = 1, limit = 7) => {
    return this.props.fetchNotification({ paginationInput: { page, limit }});
  }

  render() {
    const { classes, unread, notification } = this.props;
    const { anchorEl } = this.state;
    return (
      <React.Fragment>
        <IconButton color="inherit" onClick={this._onOpenMenu}>
          {unread ? (
            <Badge badgeContent={unread} color="secondary">
              <NotificationsIcon />
            </Badge>
          ): <NotificationsIcon />}
        </IconButton>
        <Menu
          id="notification-menu"
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={this._onCloseMenu}
        >
          {notification.map(notif => {
            const { createdAt, key, payload, read, _id } = notif;
            const date = moment(parseInt(createdAt.timestamp, 10));
            const text = texts[key] || key;
            return (
              <MenuItem
                key={_id}
                classes={{ root: classes.rowRoot }}
                className={classNames(classes.row, { [classes.rowUnread]: !read })}
                onClick={() => this._onClickNotif(notif)}
              >
                <div className={classes.texts}>
                  <Typography className={classes.text} component="div">
                    {text.replace(/\[.*?\]/g, x => {
                      const variable = trim(x, '[]');
                      if (isEmpty(payload) || isEmpty(trim(payload[variable])))
                        return variable;
                      return payload[variable] || variable;
                    })}
                  </Typography>
                  <Typography variant="caption">
                    {`${date.format('MMM D, Y')} at ${date.format('HH:mm')}`}
                  </Typography>
                </div>
                {!read && (
                  <Tooltip title={this.state.texts.alert.mark_read}>
                    <IconButton
                      className={classes.readButton}
                      onClick={event => this._onClickMark(event, _id)}
                      >
                      <RadioButtonCheckedIcon />
                    </IconButton>
                  </Tooltip>
                )}
              </MenuItem>
            );
          })}
          <Button
            component={Link}
            to="/home/notification"
            size="small"
            color="primary"
            className={classes.seeMoreButton}
            onClick={this._onCloseMenu}
          >
            {this.state.texts.button_text.see_all}
          </Button>
        </Menu>
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => ({
  loggedIn: get(state, 'auth.data.user') != null,
  userId: get(state, 'auth.data.user._id') || '',
  unread: get(state, 'notification.main.data.unread') || 0,
  notification: get(state, 'notification.main.data.notification') || [],
  locale: state.appState.locale,
});

const mapDispatchToProps = dispatch => ({
  fetchNotification: params => dispatch(fetchNotification(params)()),
  notificationMarkRead: params => dispatch(notificationMarkRead(params)()),
  dispatchNotif: params => dispatch({ type: 'SUBSCRIBE_TO_NOTIFICATION', payload: params }),
});

export default compose(
  withRouter,
  withStyles(styles, { name: 'NotificationButton' }),
  connect(mapStateToProps, mapDispatchToProps)
)(NotificationButton);



// WEBPACK FOOTER //
// ./src/modules/notification/NotificationButton/index.js